import { Component, Inject } from '@angular/core'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import { JobsKey } from '@helios/panels/jobs'
import {
  focusPanelAction,
  RootState,
  SecurityMappingLinkedPanel,
  selectActiveSession,
  selectActiveUserId,
  selectFocusedSecurityMappingFilter,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { ComponentContainer } from 'golden-layout'
import { Subject } from 'rxjs'
import { distinctUntilChanged, takeUntil, tap } from 'rxjs/operators'
import { SecurityMappingKey } from '../panel-key'
@Component({
  selector: 'hs-security-mapping',
  templateUrl: './security-mapping-panel.component.html',
  styleUrls: ['./security-mapping-panel.component.scss'],
})
export class SecurityMappingPanelComponent extends BasePanelComponent {
  panelKey = SecurityMappingKey
  private readonly _destroyed$ = new Subject<void>()
  transactionid: string | undefined
  positionid: string | undefined
  positioncusip: string | undefined
  source = 'helios'
  userid?: number
  accountid?: number

  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    private readonly store: Store<RootState>,
  ) {
    super(container)
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  ngOnInit() {
    this.store
      .select(selectActiveUserId)
      .pipe(
        takeUntil(this._destroyed$),
        distinctUntilChanged(),
        tap(userId => {
          this.userid = userId
        }),
      )
      .subscribe()

    this.store
      .select(selectActiveSession)
      .pipe(
        takeUntil(this._destroyed$),
        distinctUntilChanged(),
        tap(session => {
          this.accountid = session?.loadedAccountIds[0]
        }),
      )
      .subscribe()

    this.store
      .select(selectFocusedSecurityMappingFilter)
      .pipe(
        takeUntil(this._destroyed$),
        distinctUntilChanged(),
        tap(securityMappingFilter => {
          if (securityMappingFilter) {
            if (
              SecurityMappingLinkedPanel.EXT_TRANSACTION ==
              securityMappingFilter?.panelName
            ) {
              this.setExternalTransactionSelected(
                securityMappingFilter.extTransactionId,
              )
            } else {
              this.setExternalPositionSelected(
                securityMappingFilter.extPostionId,
                securityMappingFilter.extPositionCusip,
              )
            }
          } else {
            this.setExternalTransactionSelected(undefined)
            this.setExternalPositionSelected(undefined)
          }
        }),
      )
      .subscribe()
  }

  setExternalTransactionSelected(externalTransId: number | undefined) {
    this.transactionid = externalTransId?.toString()
    this.positionid = undefined
    this.positioncusip = undefined
  }

  setExternalPositionSelected(extPosId?: number, extPosCusip?: string) {
    this.positionid = extPosId?.toString()
    this.positioncusip = extPosCusip
    this.transactionid = undefined
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  focusJobEvent(eventData: any) {
    //const event = eventData as CustomEvent
    this.store.dispatch(focusPanelAction(JobsKey))
  }
}
